import { render, staticRenderFns } from "./RegisterWithToken.vue?vue&type=template&id=5e13a1e6&"
import script from "./RegisterWithToken.vue?vue&type=script&lang=js&"
export * from "./RegisterWithToken.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWithToken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports